import { render, staticRenderFns } from "./Curriculum-assesment-form.vue?vue&type=template&id=11f52da2&scoped=true"
import script from "./Curriculum-assesment-form.vue?vue&type=script&lang=js"
export * from "./Curriculum-assesment-form.vue?vue&type=script&lang=js"
import style0 from "./Curriculum-assesment-form.vue?vue&type=style&index=0&id=11f52da2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11f52da2",
  null
  
)

export default component.exports